import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Menu, X, Languages } from "lucide-react";

const LOGO = "/logo.png";

export default function Navbar() {
  const { t, lang, toggle } = useLang();
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();

  const scrollTo = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl border-b border-border/60 bg-background/85"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-2 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo-link">
          <img
            src={LOGO}
            alt="Flores On The Move"
            className="h-11 w-auto"
          />
        </Link>

        <nav className="hidden lg:flex items-center gap-8 text-sm">
          <button onClick={() => scrollTo("services")} className="hover:text-primary transition-colors" data-testid="nav-services">
            {t.nav.services}
          </button>
          <button onClick={() => scrollTo("about")} className="hover:text-primary transition-colors" data-testid="nav-about">
            {t.nav.about}
          </button>
          <button onClick={() => scrollTo("reviews")} className="hover:text-primary transition-colors" data-testid="nav-reviews">
            {t.nav.reviews}
          </button>
          <button onClick={() => scrollTo("gallery")} className="hover:text-primary transition-colors" data-testid="nav-gallery">
            {t.nav.gallery}
          </button>
          <button onClick={() => scrollTo("contact")} className="hover:text-primary transition-colors" data-testid="nav-contact">
            {t.nav.contact}
          </button>
        </nav>

        <div className="flex items-center gap-2">
          <button
            onClick={toggle}
            className="hidden sm:flex items-center gap-2 px-3 py-2 rounded-full border border-border hover:border-primary hover:text-primary transition-colors text-xs font-bold uppercase tracking-widest"
            data-testid="lang-toggle"
          >
            <Languages className="h-4 w-4" />
            {lang === "en" ? "EN / ES" : "ES / EN"}
          </button>
          <Button
            onClick={() => navigate("/login")}
            className="rounded-full bg-primary hover:bg-primary/90 text-primary-foreground font-semibold"
            data-testid="nav-login-btn"
          >
            {t.nav.login}
          </Button>
          <button
            className="lg:hidden p-2 rounded-md border border-border"
            onClick={() => setOpen(!open)}
            aria-label="menu"
            data-testid="mobile-menu-toggle"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-border/60 backdrop-blur-xl bg-background/95 px-6 py-4 space-y-4"
          data-testid="mobile-menu"
        >
          <button onClick={() => scrollTo("services")} className="block w-full text-left py-2">{t.nav.services}</button>
          <button onClick={() => scrollTo("about")} className="block w-full text-left py-2">{t.nav.about}</button>
          <button onClick={() => scrollTo("reviews")} className="block w-full text-left py-2">{t.nav.reviews}</button>
          <button onClick={() => scrollTo("gallery")} className="block w-full text-left py-2">{t.nav.gallery}</button>
          <button onClick={() => scrollTo("contact")} className="block w-full text-left py-2">{t.nav.contact}</button>
          <button onClick={toggle} className="flex items-center gap-2 py-2 text-primary" data-testid="lang-toggle-mobile">
            <Languages className="h-4 w-4" /> {lang === "en" ? "Switch to Español" : "Cambiar a English"}
          </button>
        </div>
      )}
    </header>
  );
}
